export default __webpack_public_path__ + "static/media/croseus_sword.fb3ece65.bmp";